import {PaymentMethod, PaymentMethodType} from "@/lib/types/billing.ts";
import {CreditCardDisplay} from "@/pages/billing/payment-method/CreditCardDisplay.tsx";
import {PaypalDisplay} from "@/pages/billing/payment-method/PaypalDisplay.tsx";
import {RadioButton} from "@/pages/billing/v2/checkout/RadioButton.tsx";

interface PaymentMethodSelectProps {
  existingPaymentMethod?: PaymentMethod;
  value?: PaymentMethod;
  setValue: (pm?: PaymentMethod) => void;
}

/**
 * payment method radio group which supports either one of Credit Card or PayPal.
 */
export const PaymentMethodSelect = ({value, setValue, existingPaymentMethod}: PaymentMethodSelectProps) => {
  // TODO: rework to use <RadioTabs /> instead?
  const radioButtonClass = "p-3 bg-gray-100";
  return (
    <div className="bg-white d-flex flex-row gap-3">
      {existingPaymentMethod?.pm_type === PaymentMethodType.CREDIT_CARD && (
        <div className="col-6">
          <RadioButton
            className={radioButtonClass}
            checked={!!value?.pm_type}
            onChange={() => setValue(existingPaymentMethod)}
          >
            <CreditCardDisplay paymentMethod={existingPaymentMethod} />
          </RadioButton>
        </div>
      )}
      {existingPaymentMethod?.pm_type === PaymentMethodType.PAYPAL && (
        <div className="col-6">
          <RadioButton
            className={radioButtonClass}
            checked={!!value?.pm_type}
            onChange={() => setValue(existingPaymentMethod)}
          >
            <PaypalDisplay paymentMethod={existingPaymentMethod} />
          </RadioButton>
        </div>
      )}
      <div className="col-6">
        <RadioButton
          className={radioButtonClass}
          checked={value === undefined || !existingPaymentMethod?.pm_type}
          readOnly={!existingPaymentMethod?.pm_type}
          onChange={() => setValue(undefined)}
        >
          <span>{existingPaymentMethod?.pm_type ? "Complete Checkout With New" : "Add New"} Payment Method</span>
        </RadioButton>
      </div>
    </div>
  );
};
